/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import { skeletonConstants } from '../constants/skeletonConstants';

export const HomePageFavoriteServiceLoader = memo<IContentLoaderProps>(props => (
  <ContentLoader
    height={284}
    width={500}
    backgroundColor={skeletonConstants.backgroundColor}
    foregroundColor={skeletonConstants.foregroundColor}
    style={{
      backgroundColor: skeletonConstants.loaderBackgroundColor,
      borderRadius: '12px',
    }}
    {...props}
  >
    {/* Title Placeholder */}
    <rect x="20" y="18" rx="6" ry="6" width="200" height="20" />

    {/* List of Favorite Clusters */}
    <rect x="20" y="60" rx="6" ry="6" width="450" height="50" />
    <rect x="20" y="120" rx="6" ry="6" width="450" height="50" />
    <rect x="20" y="180" rx="6" ry="6" width="450" height="50" />
    <rect x="20" y="240" rx="6" ry="6" width="450" height="50" />
  </ContentLoader>
));
